
import AsyncStorage from '@react-native-async-storage/async-storage';
import {configureStore} from '@reduxjs/toolkit';
import {persistReducer, persistStore} from 'redux-persist';

import {setDispatch} from './wrapDispatch';
import {reducers, tobePersistedKeys} from './rootReducer';

const persistConfig = {
  key: 'root',
  storage: AsyncStorage,
  whitelist: tobePersistedKeys,
};

const rootReducer = persistReducer(persistConfig, reducers);

export const store = configureStore({
  reducer: rootReducer,
  middleware: getDefaultMiddleware =>
    getDefaultMiddleware({
      serializableCheck: false,
      // Add additional middleware here if necessary
    }),
});
setDispatch(store.dispatch.bind(store));

export const persistor = persistStore(store as any);
export type RootState = ReturnType<typeof rootReducer>;
